import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const CampusAccess = (props) => {
    const width = props.width ? props.width + 'px' : '62px';
    const height = props.height ? props.height + 'px' : '35px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 62 35"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.0847 6.80211C23.0847 10.464 20.1758 13.4392 16.5959 13.4392C13.0203 13.4392 10.1114 10.464 10.1114 6.80211C10.1114 3.14028 13.016 0.165039 16.5959 0.165039C20.1758 0.165039 23.0847 3.14028 23.0847 6.80211ZM19.921 6.80211C19.921 4.92802 18.4305 3.40369 16.5959 3.40369C14.7656 3.40369 13.2751 4.92802 13.2751 6.80211C13.2751 8.67622 14.7614 10.2005 16.5959 10.2005C18.4305 10.2005 19.921 8.67622 19.921 6.80211ZM15.2624 27.7542H12.0987V18.3275H9.04539V15.0889H24.1505V18.3275H21.0972V27.7542H17.9335V18.3275H15.2624V27.7542ZM62.0003 30.6818H0V34.5618H62.0003V30.6818ZM28 11.0001H55V23V23.0229V27H52V23.0229H31V27H28V23.0229V23V11.0001ZM31.2019 19.7627H51.972V14.2431H31.2019V19.7627Z"
            />
        </SvgStyled>
    );
};

export default CampusAccess;
